import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Button, compareBrowserEntriesByName, translate, withDirsFirst, } from '@lucidlink/uicore';
import { FileBrowserTestIdFactory } from '#interactions';
import { BrowserNameCell } from '../FileBrowser';
import { ParentDirCell } from './components';
import { createParentDirFirstSortConfig } from './FsEntryPicker.services';
import { FsEntryPickerTestIdFactory } from './interactions';
export const fsEntryPickerColumnConfig = ({ onEntrySelect, SelectIcon, selectLabel, testId, }) => [
    {
        id: 'name',
        label: translate('Name'),
        columnGrow: 'flex-4',
        columnSize: '90x',
        columnUtility: 'overflow',
        sortConfig: createParentDirFirstSortConfig(withDirsFirst(compareBrowserEntriesByName)),
        renderData: (entry) => entry.data.isParentDir ? (_jsx(ParentDirCell, {})) : (_jsx(Box, { "data-testid": FileBrowserTestIdFactory.getEntryNameTestId(testId, entry.id), isFullWidth: true, children: _jsx(BrowserNameCell, { entry: entry }) })),
    },
    {
        id: 'select',
        ariaLabel: selectLabel,
        columnGrow: 'fixed',
        columnSize: '24x',
        stopPropagation: true,
        renderData: (entry) => entry.data.isParentDir ? null : (_jsx(Button, { "data-testid": FsEntryPickerTestIdFactory.getEntrySelectTestId(testId, entry.id), kind: "ghost", onClick: () => onEntrySelect(entry), size: "small", ...(SelectIcon && { StartIcon: SelectIcon }), children: selectLabel })),
    },
];
